import axios from 'axios';

// 1. Defina a URL completa do backend para evitar erros de proxy
// Se seu backend roda na porta 3006, aponte diretamente para ela.
const api = axios.create({
  baseURL: 'https://qelements.arpsoftware.com.br/api' 
});

api.interceptors.request.use(config => {
  // 2. CORREÇÃO CRÍTICA: O nome da chave deve ser 'app_token'
  // (Baseado no código da sua página React que usava 'app_token')
  const token = localStorage.getItem('app_token'); 
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("API: Nenhum token 'app_token' encontrado no LocalStorage.");
  }
  return config;
});

api.interceptors.response.use(
  (response) => response, 
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error("API: Erro 401 (Não autorizado). O token pode estar expirado.");
      // Opcional: só limpe se quiser forçar logout
      // localStorage.removeItem('app_token'); 
      // window.location.href = '/login'; // Descomente para forçar redirect se necessário
    }
    return Promise.reject(error);
  }
);

export default api;